import config from '../../config'; // load configurations file

import { BASE_URL, FETCH_TIMEOUT } from './constants';

export const Headers = (token, customBase) => {
	let base = customBase || { 'Content-Type': 'application/json' };
	base.Key = config.app.key;
	if (token) base.Authorization = token;
	return base;
};

const DEBOUNCE_DELAY = 300;

let requestTimers = new Map();
let activeRequests = new Map();

export function Request(url, object = {}) {
    const key = `${url}_${JSON.stringify(object)}`;
    
    return new Promise((resolve, reject) => {
        // Cancel previous timer and mark request as cancelled
        if (requestTimers.has(key)) {
            clearTimeout(requestTimers.get(key));
            if (activeRequests.has(key)) {
                activeRequests.get(key).cancelled = true;
            }
        }
        
        // Schedule new request
        const timer = setTimeout(() => {
            makeRequest(key, url, object, resolve, reject);
        }, DEBOUNCE_DELAY);
        
        requestTimers.set(key, timer);
    });
}

function makeRequest(key, url, object, resolve, reject) {
    const request = { cancelled: false };
    activeRequests.set(key, request);
    
    const timeout = setTimeout(() => {
        request.cancelled = true;
        reject(new Error('Request timed out'));
    }, FETCH_TIMEOUT);
    
    fetch(url, object)
        .then(res => request.cancelled ? null : res.json())
        .then(data => {
            clearTimeout(timeout);
            if (!request.cancelled) resolve(data);
        })
        .catch(err => {
            clearTimeout(timeout);
            if (!request.cancelled) reject(err);
        })
        .finally(() => {
            activeRequests.delete(key);
            requestTimers.delete(key);
        });
}

export default function FetchRequest(endpoint, method, token, data, customBase) {
	let url = `${BASE_URL}${endpoint}`;
	const headers = Headers(token, customBase);
	const dataParse = data instanceof FormData ? data : JSON.stringify(data);
	let body = null;

	if (method !== 'GET') body = dataParse;
	else {
		if (!(data == null)) {
			url = new URL(url);
			Object.keys(data).forEach((key) => url.searchParams.append(key, data[key]));
		}
	}

	return Request(url, { method, headers, body });
}
